import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;
const MoamadeemRep = () => {
  // State for the selected year
  const [selectedYear, setSelectedYear] = useState(null);
  const [years, setYears] = useState(null);
  const [moamadRep, setMoamadRep] = useState(null);
  const [moamadDepartmentRep, setMoamadDepartmentRep] = useState(null);
  //const [uniqueMkhTypes, setUniqueMkhTypes] = useState(null);

  // Function to handle year selection
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    // You can fetch data based on the selected year here
  };
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    let isMounted = true;
    const controller = new AbortController();

    const getYears = async () => {
      try {
        const response = await axiosPrivate
          .get(baseURL + "jobs/years/", {
            signal: controller.signal,
          })
          .then((response) => {
            setYears([
              "ללא הגבלה",
              ...response.data.years.map((member) => String(member)),
            ]);
          });
      } catch (err) {
        console.error(err);
      }
    };
    getYears();
    return () => {
      document.body.classList.remove("accountBodyColor");
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [axiosPrivate]);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getMoamadRep = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/moamadeemrep/?year=" + selectedYear,
          {
            signal: controller.signal,
          },
        );

        if (isMounted) {
          setMoamadRep(response.data[0]);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    const getMoamadDepartmentRep = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/moamaddepartmentrep/?year=" + selectedYear,
          {
            signal: controller.signal,
          },
        );

        if (isMounted) {
          setMoamadDepartmentRep(response.data);

          /*setUniqueMkhTypes([
            ...new Set(response.data.map((item) => item.mkh_type_display)),
          ]);*/
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };

    getMoamadRep();
    getMoamadDepartmentRep();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [selectedYear, axiosPrivate]);

  return (
    <div>
      {/* First line: Dropdown to select a year */}
      <h2 style={{ textAlign: "center", color: "white" }}>
        {selectedYear && selectedYear !== "ללא הגבלה"
          ? `סטטיסטיקה של ההגשות לשנת ${selectedYear}`
          : "סטטיסטיקה של ההגשות ללא הגבלת שנה"}
      </h2>
      <div>
        <label
          style={{ color: "black", fontWeight: "bold", marginLeft: "10px" }}
        >
          בחר שנה להצגה:
        </label>

        <select onChange={handleYearChange} value={selectedYear}>
          {years?.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <br />
        <br />
      </div>

      {/* Second part: Two blocks with statistics */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            marginLeft: "20px",
            flex: 1,
            backgroundColor: "rgb(200, 200, 200)",
          }}
        >
          <h2>
            {selectedYear
              ? `סטטיסטיקה של ההגשות לשנת ${selectedYear}`
              : "סטטיסטיקה של ההגשות ללא הגבלת תקופה"}
          </h2>
          <div
            style={{ color: "black", fontWeight: "bold" }}
            className="rightmargin"
          >
            <p>
              המספר הכולל ההגשות: {moamadRep?.moamadall} שהוגשו ע"י{" "}
              {moamadRep?.moamadusers} משתמשים
            </p>
            <p> זכר: {moamadRep?.moamadmale}</p>
            <p> נקבה: {moamadRep?.moamadfemale}</p>
            <p> עמדו בתנאי הסף: {moamadRep?.moamadsaf}</p>
            {/* Add more statistics as needed */}
          </div>
        </div>

        {/* Block 2 */}
        <div
          style={{
            marginRight: "20px",
            flex: 1,
            backgroundColor: "rgb(200, 200, 200)",
          }}
        >
          <h2>מספר המועמדים מהאוכלסיות המיוחדות</h2>
          <div
            style={{ color: "black", fontWeight: "bold" }}
            className="rightmargin"
          >
            <p>האוכלוסיה הערבית, הדרוזית או הצרקסית: {moamadRep?.moamadarab}</p>
            <p>אתיופי: {moamadRep?.moamadetiopi}</p>
            <p>בעל צרכים מיוחדים: {moamadRep?.moamadspecial_needs}</p>
            {/* Add more statistics as needed */}
          </div>
        </div>
      </div>
      {/* Another block below the two existing blocks */}
      <div style={{ marginTop: "20px", backgroundColor: "rgb(200, 200, 200)" }}>
        <center>
          {" "}
          <h2>התפלגות המכרזים לפי המחלקות</h2>
        </center>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          <table>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מחלקה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מספר ההגשות
                </th>
              </tr>
            </thead>
            <tbody>
              {moamadDepartmentRep?.map((item, index) => {
                const pct = Math.round(
                  (item.moamad_count / moamadRep?.moamadall) * 100,
                );
                return (
                  <tr style={{ borderBottom: "1px solid #ddd" }} key={index}>
                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.department_title}
                    </td>
                    <td
                      className="padding10-td"
                      style={{ textAlign: "center" }}
                    >
                      {item.moamad_count}
                    </td>
                    <td style={{ padding: "6px 10px", minWidth: "120px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            minWidth: 0,
                            height: "12px",
                            background: "#bbb",
                            borderRadius: "5px",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              width: `${pct}%`,
                              height: "100%",
                              background: "#3399ff",
                              borderRadius: "5px",
                              minWidth: pct > 0 ? "4px" : "0",
                            }}
                          />
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#555",
                            minWidth: "28px",
                          }}
                        >
                          {pct}%
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default MoamadeemRep;
